import { Notifications } from '@orbital/games-frontend-library'
import React from 'react'
import Button from '../../../components/elements/button/Button'
import NumberInput from '../../../components/elements/NumberInput/NumberInput'
import { cyberColors } from '../../../lib/colors'

import UseProvablyHandlers from '../helperFunctions/UseProvablyHandlers'
import Notify from './Notify'
import { logger } from '../../../helpers/logger/logger'

export default function SeedForm({ sendSeed, autoPlayIsOn }: any) {
  const { handleChange, handleSubmit, seed, seedError, fadeOut } =
    UseProvablyHandlers(
      sendSeed,
      // handleNotification,
      // audio,
    )
  const handleChangeSeed = (seed: string) => handleSubmit(seed)

  return (
    <form
      autoComplete='off'
      onSubmit={e => {
        e.preventDefault()
      }}
      // onClick={() =>
      //   roundIsOn && handleNotification(Notifications.cantChangeSeed)
      // }
    >
      <NumberInput
        value={seed}
        handleBlur={() => logger.log('blur')}
        handleChange={handleChange}
        title='NEW SEED'
        placeholder={'-'}
        fontSize='18px'
        width='100%'
        height='55px'
        padding='7px 10px'
        color={seedError ? cyberColors.red : '#c4c9dd'}
        h='24px'
        maxWidth={'unset'}
        y={1}
        isError={seedError}
        margin={'0 0 5px 0'}
        inputMode='text'
        autoPlayIsOn={autoPlayIsOn}
      />
      {seedError && (
        <Notify
          text={Notifications.invalidSeed}
          error={seedError}
          fadeOut={fadeOut}
        />
      )}
      <Button
        width={'100%'}
        background={cyberColors.blueGradient}
        size={'26px'}
        margin={'5px 0 0'}
        func={() => handleChangeSeed(seed)}
        autoPlayIsOn={autoPlayIsOn}
      >
        <p>set</p>
      </Button>
    </form>
  )
}
